import { escapeHtml, readFormField } from '../ad_campaign/dom-helpers';
import { MATERIAL_FORMATS, materialIdAttr, $materialPanel } from './materials';

function infoCol(label: string, value: string): string {
  const display = value ? escapeHtml(value) : '<span class="text-muted">—</span>';
  return `<div class="col-md-6 mb-3">
       <h6 class="mb-1">${escapeHtml(label)}</h6>
       <div class="font-weight-bold campaign-info-value">${display}</div>
     </div>`;
}

function formatDate(value: string): string {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString(undefined, {
    year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit',
  });
}

export function populateAdSetReview(): void {
  const $body = $('#ad-set-modal-body');

  const campaignName = $body.find('[data-role="adset-campaign-select"] option:selected').text().trim();

  const audienceName = $body.attr('data-audience-name');
  const $audience = $('[data-role="adset-summary-audience"]').empty();
  if (audienceName) {
    $audience.html(`<div class="font-weight-bold">${escapeHtml(audienceName)}</div>`);
  } else {
    $audience.html('<span class="text-muted">No audience selected</span>');
  }

  const $details = $('[data-role="adset-summary-details"]').empty();
  $details.append(infoCol('Ad Campaign', campaignName && campaignName !== 'Loading campaigns…' ? campaignName : ''));
  $details.append(infoCol('Ad Set Name', readFormField($body, 'name')));
  $details.append(infoCol('Primary Text', readFormField($body, 'primary_text')));
  $details.append(infoCol('Headline', readFormField($body, 'headline')));
  $details.append(infoCol('Description', readFormField($body, 'description')));
  $details.append(infoCol('Link to page', readFormField($body, 'link_to_page')));
  $details.append(infoCol('Start Time', formatDate(readFormField($body, 'start_time'))));
  $details.append(infoCol('End Time', formatDate(readFormField($body, 'end_time'))));
  const geoLabels = $body
    .find('[data-role="adset-geo-location"] input[type="checkbox"]:checked')
    .map((_i, el) => $(el).closest('.form-check').find('.form-check-label').text().trim())
    .get();
  $details.append(infoCol('Geographic locations', geoLabels.join(', ')));

  const $materials = $('[data-role="adset-summary-materials"]').empty();
  MATERIAL_FORMATS.forEach(fmt => {
    const id = $body.attr(materialIdAttr(fmt));
    const $panel = $materialPanel(fmt);
    const targetWidth = $panel.data('material-width');
    const targetHeight = $panel.data('material-height');
    const labelText = `${fmt === 'square' ? 'Square' : 'Story'} (${targetWidth} x ${targetHeight})`;

    if (!id) {
      $materials.append(
        `<div class="summary-material">
           <span class="summary-material-label text-secondary">${escapeHtml(labelText)}</span>
           <div class="summary-material-thumb"></div>
           <span class="summary-material-name text-muted">No material selected</span>
         </div>`
      );
      return;
    }

    const $card = $panel.find(`.image-card[data-material-id="${id}"]`);
    const name = $card.find('.card-title').text() || `Material #${id}`;
    const isVideo = $card.find('video').length > 0;
    const src = (isVideo ? $card.find('video').attr('src') : $card.find('img').attr('src')) ?? '';

    let thumbContent = '';
    if (src && isVideo) {
      thumbContent = `<video src="${escapeHtml(src)}" muted preload="metadata"></video>`;
    } else if (src) {
      thumbContent = `<img src="${escapeHtml(src)}" alt="${escapeHtml(name)}">`;
    }

    $materials.append(
      `<div class="summary-material mb-2">
         <span class="summary-material-label text-secondary">${escapeHtml(labelText)}</span>
         <div class="bg-white d-flex align-items-center summary-material-thumb-wrapper">
          <div class="summary-material-thumb mr-3">${thumbContent}</div>
          <span class="summary-material-name font-weight-bold">${escapeHtml(name)}</span>
         </div>
       </div>`
    );
  });
}
